module.exports = __webpack_public_path__ + "static/media/map.bdd2b13e.png";